import { ProviderStore } from 'src/domains/casino/state/AppCasino/store/provider-store/Provider.store';
import { GameStore } from 'src/domains/casino/state/AppCasino/store/game-store/Game.store';
import { CollectionType } from 'src/domains/casino/models/models';
import { ConfigState } from 'src/AppState/ConfigState/ConfigState';
import { RedirectState } from './AppCasino/Redirect.state';
import { RouterBackoffice } from 'src/AppState/RouterBackoffice';
import { Common } from 'src/AppState/Common';

export class AppCasinoState {
    public readonly providerStore: ProviderStore;
    public readonly gameStore: GameStore;
    public readonly redirectState: RedirectState;
    private readonly configState: ConfigState;

    public constructor(
        common: Common,
        private readonly routerBackoffice: RouterBackoffice
    ) {
        this.configState = ConfigState.get(common);
        this.providerStore = new ProviderStore(common);
        this.gameStore = new GameStore(common);
        this.redirectState = new RedirectState(this.routerBackoffice);
    }

    public isCollectionAvailable = (collection: CollectionType): boolean => {
        // TODO: Remove before develop bingo
        if (collection === 'bingo') {
            return false;
        }
        if (this.configState.config.casinoProviders[collection].length > 0) {
            return true;
        }
        return false;
    };
}
